import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import './Loader.css'

const Loader = ({ instant, text, className }) => {
  const classes = classNames({
    'loader': true,
    'loader--instant': instant,
  }, className)

  const loader = (
    <div className={classes}>
      <div className="loader__shadow"></div>
      <div className="loader__spinner"></div>
      <div className="loader__text">{text || 'Loading...'}</div>
    </div>
  )

  return loader
}

Loader.propTypes = {
  text: PropTypes.string,
  instant: PropTypes.bool,
  className: PropTypes.string,
}

export default Loader



// WEBPACK FOOTER //
// ./src/Components/Loader/Loader.js